<template>
  <main class="main">

    <the-nav-titles></the-nav-titles>

    <div class="container">
      <h1 class="title title_h1">{{ title }}</h1>
    </div>

    <div
      v-if="!loaded"
      class="loader"
    ></div>

    <div
      v-else
      class="container"
    >

      <div
        v-for="(section, index) in sections"
        :key="index"
        class="layout layout_default-page"
      >

        <div class="layout__item">
          <h2 class="title title_h2">{{ section.title }}</h2>
        </div>

        <div
          v-html="section.text"
          class="layout__item privacy"
        >
        </div>
      </div>

    </div>

  </main>
</template>

<script>
  import TheNavTitles from '@/components/TheNavTitles';

  export default {
    name: 'CertificazioniPage',

    components: {
      TheNavTitles,
    },

    data() {
      return {
        loaded: false,
        sections: [],
        title: 'Certificazioni',
      };
    },

    created() {
      this.fetchData();
    },

    methods: {
      fetchData() {
        this.$http
            .get('/static/api/certificazioni.json')
            .then(this.onFulfilled);
      },

      onFulfilled(res) {
        const data = res.data;

        this.sections = data.content.sections;
        this.loaded = true;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/certificazioni/Index.vue